<template>
  <section id="home-seo">
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="lead">Website Spesifikasi Lengkap dan Review Laptop No. 1 di Indonesia</p>
          <div class="description" :class="{ 'show': show }">
            <p>Sebagai website spesifikasi lengkap dan review laptop no. 1 di Indonesia. PilihLaptop.com diluncurkan pada April 2020 sebagai jawaban atas tantangan kebutuhan informasi yang akurat tentang produk-produk IT khususunya Laptop. PilihLaptop.com disupport oleh retail dan brand yang bekerjasama untuk menyediakan produk real sehingga dapat direview secara aktual oleh team PilihLaptop.com. Memiliki standart operasional yang ketat menghasil informasi spesifikasi lengkap, unboxing dan review dari PilihLaptop.com yang aktual dan objektif. Hasil review PilihLaptop.com dapat menjadi acuan tepat dalam memilih dan menentukan produk laptop yang akan dibeli.</p>
            <p>Kami tidak hanya menghadirkan spesifikasi lengkap berdasarkan unboxing langsung produk yang ada di pasaran, namun juga memberikan review dan penilaian dari hasil pengujian oleh team PilihLaptop.com. PilihLaptop.com juga menghadirkan real photo dan video dari produk yang kami review sehingga anda dapat memiliki gambaran yang lengkap tentang produk yang akan anda beli.</p>
            <p>PilihLaptop.com berharap akan terus berkembang tidak hanya hadir di <strong>Website</strong> PilihLaptop (https://www.pilihlaptop.com) saja namun juga dapat memberikan informasi melalui berbagai media. Selain informasi spesifikasi lengkap dan review latop kami juga menghadirkan informasi tentang perkembangan dan trend teknologi terbaru di <strong>Blog</strong> PilihLaptop.com (https://www.pilihlaptop.com/news). PilihLaptop.com juga menghadirkan konten informatif melalui Social Media yang dapat anda ikuti diantaranya <strong>Instagram</strong> ( https://www.instagram.com/PilihLaptop ), <strong>Twitter</strong> ( https://www.twitter.com/PilihLaptop ), dan <strong>Facebook</strong> ( https://www.facebook.com/PilihLaptopID ).</p>
            <p>Kami terus berharap bertumbuh dan berkembang seiring dengan perkembangan teknologi khususnya laptop. Kami terus berusaha menghadirkan yang terbaik, menerima masukan dan saran, serta membuka seluas-luasnya peluang kerjasama dengan semua pihak. Untuk itu kami sangat terbuka apabila anda memiliki peluang baru yang dapat dikolaborasikan dengan kami dapat menghubungi kami di Email : hi@pilihlaptop.com</p>
            <p>Semua ini dihadirkan oleh PilihLaptop.com untuk memberikan pengalaman menemukan produk pilihan yang lengkap, bisa diandalkan, dan terpercaya. Karen <strong>PilihLaptop</strong>.com adalah <strong>Website Spesifikasi Lengkap dan Review Laptop No. 1 di Indonesia</strong></p>
            <button
              id="show-more"
              v-scroll-to="'#home-seo'"
              class="btn btn-sm btn-light"
              :class="{ 'show': show }"
              @click="toggle">
              <i class="fad fa-chevron-double-down"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSEO',

  data() {
    return {
      show: false,
    };
  },

  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
  #home-seo {
    border-top: 1px solid $grey-fade;
    font-size: 13px;
    line-height: 1.75;
    text-align: justify;

    @include media ("<=tablet") {
      text-align: left;
    }

    p.lead {
      margin-bottom: 1rem;
      color: $color-secondary;
    }

    .description {
      position: relative;
      max-height: 10rem;
      transition: all 0.3s ease;
      overflow: hidden;
      color: $grey-medium;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 6rem;
        background: linear-gradient(0deg, rgba($white,1) 0%, rgba(white,0.4) 100%);
        z-index: 1;
      }

      p:last-child {
        margin-bottom: 5rem;
      }

      &.show {
        max-height: 100rem;
        padding-bottom: 2rem;

        &::after {
          display: none;
        }
      }
    }

    #show-more {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: inline-block;
      margin: 0 auto;
      z-index: 2;
      border: 1px solid $grey;
      font-size: 1rem !important;
      background-color: $white;
      transition: all 0.3s ease;

      &:hover {
        color: $color-primary;
      }

      &:focus {
        outline: none;
        box-shadow: none;
      }

      &.show {
        transform: rotate(180deg);
      }
    }
  }
</style>
